import { Component, Input, OnInit } from '@angular/core';

import { Course } from 'lms-api';
import { CourseFilterService } from '../_services/course-filter.service';
import { LmsUserService } from 'lms-api';

@Component({
  selector: 'app-course-listview-list',
  templateUrl: './course-listview-list.component.html',
  styleUrls: ['./course-listview-list.component.scss']
})
export class CourseListviewListComponent implements OnInit {
  @Input() courses: Course[];

  constructor(private lmsUserService: LmsUserService, private courseFilterService: CourseFilterService) { }

  ngOnInit() {
  }

  courseId(index: number, course: Course) {
    return course.netforum_course_id;
  }

}
